module.exports = __webpack_public_path__ + "static/assets/bfa524710c692984e3e50c2fd721b73b.png";